const sidebar = {
  groupCore: "Основные",
  groupTools: "Инструменты",
  groupSystem: "Система",
  filterMe: "Me",
  filterTeam: "Команда",
  filterHidden: "Скрытые",
  filterFavorites: "Избранное",
  viewList: "Список",
  viewGrid: "Сетка",
  viewCompact: "Компактно",
  viewFolders: "Папки",
  viewFlat: "Плоский",
  editMode: "Настроить",
  doneEditing: "Готово",
  autoSort: "Сортировка по использованию",
  resetOrder: "Сбросить",
  resetConfirm: "Сбросить все настройки?",
  hide: "Скрыть",
  show: "Показать",
  openNewTab: "Открыть в новой вкладке",
  addFav: "В избранное",
  removeFav: "Из избранного",
  moveToFolder: "Переместить в папку...",
  newFolder: "Новая папка...",
  removeFromFolder: "Убрать из папки",
  folderName: "Имя папки",
  addNote: "Добавить заметку",
  editNote: "Редактировать заметку",
  hiddenCount: "скрытых",
  itemEdit: "Редактировать вкладку",
  customLabel: "Свое название",
  language: "Язык отображения",
  iconPosition: "Позиция иконки",
  changeIcon: "Сменить иконку",
  resetItem: "Сбросить вкладку",
  langHe: "עברית",
  langEn: "English",
  langRu: "Русский",
  langCustom: "Свое",
  posStart: "Начало",
  posEnd: "Конец",
  posAbove: "Сверху",
  addSection: "Добавить раздел",
  newSectionName: "Название раздела...",
  deleteSection: "Удалить раздел",
  appFolders: "Папки приложений",
  allApps: "Все приложения",
  newAppFolder: "Новая папка",
  appFolderNamePlaceholder: "Имя папки...",
  createFirstFolder: "Создать первую папку",
  addToFolders: "Добавить в папки",
  inNFolders: "В {count} папках",
  manageFolders: "Управление папками",
  navItemsSection: "Элементы меню",
  deleteFolderConfirm: 'Удалить папку "{name}"?',
} as const;
export default sidebar;
